import * as CalendarEventComponents from "../../../../Models/Components/CalendarEvent";
import { EventTooltipProps } from "../../types";

export function DefaultEventTooltip({ item, ...props }: EventTooltipProps) {
	return <CalendarEventComponents.CalendarEventTooltip calendarEventID={item.id} {...props} />;
}
